"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertProvider = exports.AlertContext = exports.getDefaultAlertPayload = void 0;
const react_1 = __importDefault(require("react"));
const BaseAlert_1 = __importDefault(require("./BaseAlert"));
const types_1 = require("./types");
const getDefaultAlertOptions = () => ({
    duration: 3000,
    location: { vertical: 'top', horizontal: 'center' }
});
const getDefaultAlertPayload = () => ({
    variant: types_1.AlertVariant.SUCCESS,
    styleVariant: types_1.AlertStyleVariant.FILLED,
    open: false,
    title: null,
    body: null,
    unmountOnClose: true,
    options: getDefaultAlertOptions(),
    forceClose: false
});
exports.getDefaultAlertPayload = getDefaultAlertPayload;
const resolvePayload = (props) => {
    const { options } = props;
    const alertPayload = Object.assign(Object.assign({}, exports.getDefaultAlertPayload()), props);
    const updatedOptions = Object.assign(Object.assign({}, getDefaultAlertOptions()), options);
    return Object.assign(Object.assign({}, alertPayload), { options: updatedOptions });
};
const alertReducer = (state, action) => {
    switch (action.type) {
        case 'OPEN_ALERT':
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(action.payload)), { unmountOnClose: true, open: true });
        case 'CLOSE_ALERT':
            return Object.assign(Object.assign({}, state), { open: false, unmountOnClose: true });
        default:
            return Object.assign(Object.assign({}, state), { open: false, unmountOnClose: true });
    }
};
exports.AlertContext = react_1.default.createContext(exports.getDefaultAlertPayload());
const AlertProvider = props => {
    const [state, dispatch] = react_1.default.useReducer(alertReducer, exports.getDefaultAlertPayload());
    const openAlert = (payload) => {
        dispatch({ type: 'OPEN_ALERT', payload });
    };
    const closeAlert = () => {
        if (state.onClose)
            state.onClose();
        dispatch({ type: 'CLOSE_ALERT' });
    };
    return (react_1.default.createElement(exports.AlertContext.Provider, { value: [state, { openAlert, closeAlert }] },
        react_1.default.createElement(BaseAlert_1.default, Object.assign({}, state, { onClose: closeAlert })),
        props.children));
};
exports.AlertProvider = AlertProvider;
